<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('linha-produto') }}:</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('vendas') : $t('promotor')
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t('produto') : $t('cadastros')
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: isVenda ? 'produtos-linha' : 'linhas',
                                            })
                                        "
                                        >{{ $t('linhas-produto') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !lp.idlinhaproduto ? $t('nova-linha-produto') : lp.descricao
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: isVenda ? 'ven-produto-linha' : 'linhas',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !linhaIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="lp.idlinhaprodutoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!lp.idlinhaprodutoerp"
                                tooltipLabel="cod-ref"
                                :disabled="linhaIntegracao"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                v-model="lp.descricao"
                                :placeholder="'descricao-da-linha-placeholder'"
                                :maxlength="100"
                                :title="'descricao-da-linha-produto'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!lp.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                                :disabled="linhaIntegracao"
                            />
                        </div>
                        <div class="column is-4">
                            <vs-select
                                :id="generateId(3)"
                                ref="gpSelect"
                                :title="'grupo-linha-produto'"
                                :options="grupos"
                                v-model="grupo"
                                :search="loadGrupo"
                                :onChange="updateGrupo"
                                :focusin="loadGrupo"
                                :keydown="tabSelectGrupo"
                                :placeholder="'grupo-do-sub-grupo-placeholder'"
                                :invalid="!lp.grupoproduto"
                                :required="true"
                                tooltipLabel="info-grupo-linhaproduto"
                                :disabled="linhaIntegracao"
                            />
                        </div>
                        <div class="column is-6">
                            <vs-select
                                :id="generateId(4)"
                                ref="subgrupoInput"
                                :title="'sub-grupo-linha-produto'"
                                :options="subgrupos"
                                v-model="subgrupo"
                                :search="loadSubGrupo"
                                :onChange="updateSubgrupo"
                                :keydown="tabSelectSubGrupo"
                                :placeholder="'sub-grupo-linha-placeholder'"
                                :invalid="!lp.subgrupoproduto"
                                :disabled="!lp.grupoproduto || linhaIntegracao"
                                required
                                tooltipLabel="info-subgrupo-linhaproduto"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(5)"
                                ref="situacaoSelect"
                                :options="situacoes"
                                v-model="situacao"
                                @input="updateSituacao"
                                :disabled="!isUpdate || linhaIntegracao"
                                tooltipLabel="info-situacao-generica"
                                title="situacao"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LinhaProdutoService from '@/services/LinhaProdutoService';
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import LinhaValidation from '@/services/validations/LinhaValidation';
import Message from '@/models/Message';

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged && this.flag === 0) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    data() {
        return {
            linhaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('LINHAPRODUTO'),
            service: null,
            gruposervice: null,
            subgruposervice: null,
            validation: null,
            isSaving: false,
            lp: {
                situacao: 1,
                idlinhaprodutoerp: null,
                subgrupoproduto: null,
            },
            editable: false,
            title: '',
            msgs: [],
            grupo: null,
            grupos: [],
            subgrupo: null,
            subgrupos: [],
            loadGroup: false,
            loadSubGroup: false,
            canSelectSubGrupo: false,
            canSelectGrupo: false,
            situacao: { label: this.$t('ativo'), id: 1 },
            situacoes: [
                { label: this.$t('ativo'), id: 1 },
                { label: this.$t('inativo'), id: 0 },
            ],
            isUpdate: false,
            // @84562 - Adicionado variável para verificar a origem da rota
            // Esta variável é utilizada sempre que for verificado se a origem da rota é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
            empresas: [],
            sort: {
                order: 'desc',
                column: 'DESCRICAO',
            },
            isChanged: false,
            flag: 0,
        };
    },
    created() {
        if (this.lp != null && this.lp != {}) {
            this.editable = true;
        }

        this.service = new LinhaProdutoService(this.$http, this.$router);
        (this.gruposervice = new GrupoProdutoService(this.$http, this.$router)),
            (this.subgruposervice = new SubGrupoProdutoService(this.$http, this.$router)),
            (this.validation = new LinhaValidation(this.msgs)),
            (this.permissao = this.isVenda
                ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-linha')
                : this.hasPermissionAccess('promotor', 'cadastros', 'linhas'));
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'linhas-produto' },
            });
        } else {
            this.isUpdate = this.$route.params.id ? true : false;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'linha-produto' },
                });
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
        this.loadEmpresasId();
        this.loadGrupo('');
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    watch: {
        lp: {
            deep: true,
            handler: function () {
                this.isChanged = true;
            },
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        loadEmpresasId() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            }
        },
        tabSelectGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectGrupo = true;
            if (e.code == 'Tab' && this.canSelectGrupo) {
                this.$refs.gpSelect.typeAheadSelect();
                setTimeout(() => {
                    this.$refs.subgrupoInput.focus();
                }, 200);
            }
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.lp.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        tabSelectSubGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectSubGrupo = true;
            if (e.code == 'Tab' && this.canSelectSubGrupo) {
                this.$refs.subgrupoInput.typeAheadSelect();
                this.$refs.subgrupoInput.focus();
            }
        },
        carregarDados(id) {
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.lp = body.content;
                        this.title = this.lp.descricao;
                        this.situacao = this.situacoes.filter((s) => s.id == this.lp.situacao)[0];
                        if (!this.situacao) {
                            this.situacao = this.situacoes[0];
                        }

                        if (this.lp.grupoproduto) {
                            this.grupo = {
                                id: this.lp.grupoproduto.idgrupoproduto,
                                label: this.lp.grupoproduto.descricao,
                            };
                        }
                        if (this.lp.subgrupoproduto) {
                            this.subgrupo = {
                                id: this.lp.subgrupoproduto.idsubgrupoproduto,
                                label: this.lp.subgrupoproduto.descricao,
                            };
                        }
                    } else {
                        this.$router.push({
                            name: isVenda ? 'produtos-new-linha' : 'new-linha',
                        });
                    }
                })
                .finally((_) => {
                    this.isChanged = false;
                });
        },
        loadGrupo(search = '') {
            let empresas = '0, ';
            for (let e of this.empresas) {
                empresas += `${e.id}, `;
            }
            empresas = empresas.slice(0, -2);
            this.gruposervice.findAllComboWithEmpresa(empresas, search).then((body) => {
                this.grupos = [];
                body.content.map((r) => {
                    let grupo = {
                        id: r.idgrupoproduto,
                        label: r.descricao,
                    };
                    this.grupos.push(grupo);
                });
                this.grupos.sort();
            }, 350);
        },
        loadSubGrupo() {
            let grupo = this.grupo.id;
            this.subgruposervice
                .findAll(0, 50, this.sort, grupo, 1, '')
                .then((body) => {
                    this.subgrupos = [];
                    body.content.map((r) => {
                        let subgrupo = {
                            id: r.idsubgrupoproduto,
                            label: r.descricao,
                        };
                        this.subgrupos.push(subgrupo);
                    });
                })
                .catch((e) => {})
                .finally((_) => {
                    this.subgrupo = null;
                    this.lp.subgrupoproduto = null;
                });
        },
        salvar(redirect = this.redirectToList) {
            this.flag = 1;
            this.isSaving = true;
            let idsubgrupo = 0;
            if (this.subgrupo) {
                this.lp.subgrupoproduto = {
                    idsubgrupoproduto: this.subgrupo.id,
                };
                idsubgrupo = this.subgrupo.id;
            }
            if (this.grupo) {
                this.lp.grupoproduto = { idgrupoproduto: this.grupo.id };
            }
            this.lp.descricao = this.mapTosave(this.lp.descricao);
            if (this.validation.validate(this.lp, this.$refs)) {
                this.service
                    .save(this.lp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-linha-salva';
                            if (this.lp.id) {
                                msg = 'msg-linha-editada';
                            }
                            this.lp = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            redirect(2);
                        } else {
                            this.isSaving = false;
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: this.lp.idlinhaprodutoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        this.flag = 0;
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
        redirectToList(time) {
            this.isChanged = false;
            setTimeout(() => {
                this.$router.push({
                    name: this.isVenda ? 'ven-produto-linha' : 'linhas',
                });
            }, time * 1000 + 50);
        },
        redirectToEdit(time) {
            setTimeout(() => {
                this.$router.push({
                    name: this.isVenda ? 'produtos-edit-linha' : 'edit-linha',
                    params: { id: this.lp.idlinhaproduto },
                });
            }, time * 1000 + 50);
        },
        updateGrupo(gp) {
            if (gp) {
                this.lp.grupoproduto = gp.id;
                this.grupo = gp;
                if (this.lp.grupoproduto) {
                    this.loadSubGrupo();
                }
            } else {
                this.lp.grupoproduto = null;
                this.grupo = null;
                this.updateSubgrupo(null);
            }
        },
        updateSubgrupo(sgp) {
            if (sgp) {
                this.lp.subgrupoproduto = sgp.id;
                this.subgrupo = sgp;
            } else {
                this.lp.subgrupoproduto = null;
                this.subgrupo = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
